import React, { useEffect, useState } from 'react'
import axios from 'axios';
import { ResponsiveScatterPlot } from '@nivo/scatterplot';
import LoadingScreen from '../../LoadingScreen';

const ScatterPlot = () => {
    const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const generateWholeNumbersYAxis = (data) => {
    const maxTicketSales = Math.max(...data.map((d) => d.ticketsSold));
    return Array.from({ length: maxTicketSales + 1 }, (_, index) => index);
  };

  useEffect(() => {
    
    axios
      .get('https://event-finder12.onrender.com/data/event-popularity')
      .then((response) => {
        setData(response.data);
        setLoading(false); 
        console.log(response.data)
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, []);

  return (
    <div >
      {loading ? <LoadingScreen /> : 
      <div style={{ height: '25vh', width:"100%" }}>
        <h4 style={{marginTop:"-1em"}}>Event Popularity by Ticket Price</h4>
      <ResponsiveScatterPlot
        data={[
          {
            id: 'events',
            data: data.map((item, index) => ({
              id: `event-${index}`,
              x: item.price,
              y: item.ticketsSold,
            })),
          },
        ]}
        margin={{ top: 20, right: 50, bottom: 50, left: 60 }}
        xScale={{ type: 'linear', min: 0, max: 'auto' }}
        yScale={{ type: 'linear', min: 0, max: 'auto' }}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Ticket Price',
          legendPosition: 'middle',
          legendOffset: 36,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Tickets Sold',
          legendPosition: 'middle',
          legendOffset: -50,
          tickValues: generateWholeNumbersYAxis(data),
        }}
        colors={["#6563FF"]}
        tooltip={({ node }) => (
          <strong style={{fontSize:"0.8rem"}}>
            Price: {node.data.x}, Tickets Sold: {node.data.y}
          </strong>
        )}
      />
    </div>
  }
    </div>
  );
}

export default ScatterPlot